/**
 * Utilitários para detecção de domínio (slug vs sysigreja principal)
 */

const MAIN_APP_DOMAINS = [
  "sysigreja.com",
  "www.sysigreja.com",
  "localhost",
  "127.0.0.1",
] as const;

/**
 * Verifica se hostname é um IP (IPv4 ou IPv6)
 */
export function isIP(hostname: string): boolean {
  const ipv4Pattern = /^(\d{1,3}\.){3}\d{1,3}$/;
  const ipv6Pattern = /:/;
  return ipv4Pattern.test(hostname) || ipv6Pattern.test(hostname);
}

/**
 * Verifica se é um IP privado (192.168.x.x, 10.x.x.x, 172.x.x.x)
 */
export function isPrivateIp(hostname: string): boolean {
  return (
    hostname.startsWith("192.168.") ||
    hostname.startsWith("10.") ||
    hostname.startsWith("172.")
  );
}

/**
 * Retorna o slug do hostname (primeiro segmento antes do ponto).
 * Retorna string vazia para IPs e localhost.
 */
export function getHostnameSlug(): string {
  const hostname = window.location.hostname;
  if (isIP(hostname) || hostname === "localhost") return "";
  return hostname.split(".")[0];
}

/**
 * Retorna true quando o path de eventos deve ser simplificado: /identificador
 * Em vez do formato completo: /login/identificador/inscricoes
 *
 * Inclui:
 * - recon.iecbeventos.com.br, recon.sysigreja.com (slug no subdomínio)
 * - somospaes.com.br, aeimpacto.com.br, cafecomdeuscaruaru.com.br (domínios customizados)
 */
export function isSlugDomain(): boolean {
  const h = window.location.hostname;
  if (isIP(h) || isPrivateIp(h)) return false;
  return !MAIN_APP_DOMAINS.includes(h as (typeof MAIN_APP_DOMAINS)[number]);
}

/**
 * Slug da organização na URL pública.
 * No subdomínio (recon.sysigreja.com) usa o hostname — igual ao site da igreja.
 * No domínio principal (sysigreja.com / localhost) usa o 1º segmento do path (`/:login`).
 */
export function getPublicOrgSlug(pathLogin?: string | null): string {
  if (isSlugDomain()) return getHostnameSlug();
  return (pathLogin ?? "").trim();
}

/** URL canônica da lista de links: https://{slug}.sysigreja.com/links[/{pageSlug}] */
export function buildPublicLinksUrl(
  orgSlug?: string | null,
  pageSlug?: string | null,
): string {
  const page = pageSlug?.trim();
  const path = page ? `/links/${page}` : "/links";
  const first = orgSlug?.split(",")[0]?.trim().toLowerCase();
  if (!first || first === "null" || first === "undefined") return path;
  return `https://${first}.sysigreja.com${path}`;
}
